import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link as Routerlink } from 'react-router-dom'
const Dropdown = () => {
    return (
        <Nav className="flex flex-col bg-yellow-500 text-white space-y-2 block md:hidden "> 
            <div className='text-center items-center flex flex-col mt-2'>
                <Routerlink to='/' className=' hover:text-green-600 hover:outline outline-3 outline-offset-2 cursor-pointer rounded-md '>HOME</Routerlink>
                <Routerlink to="/OurProgram" className=' hover:text-green-600 hover:outline outline-3 outline-offset-2 cursor-pointer rounded-md '>OUR PROGRAMS</Routerlink>
                <Routerlink to="/Loan" className=' hover:text-green-600 hover:outline outline-3 outline-offset-2 cursor-pointer rounded-md'>LOAN</Routerlink>
                <Routerlink to="/Research" className=' hover:text-green-600 hover:outline outline-3 outline-offset-2 cursor-pointer rounded-md'>RESEARCH</Routerlink>
                <Routerlink to="/Gov" className=' hover:text-green-600 hover:outline outline-3 outline-offset-2 cursor-pointer rounded-md'>USEFUL GOV LINKS</Routerlink>
                <Routerlink to="/Contact" className=' hover:text-green-600 hover:outline outline-3 outline-offset-2 cursor-pointer rounded-md'>CONTACT US</Routerlink>
            </div>

            <div className='space-x-2 mb-2'>
                  {/* LOGIN */}
                  <a href="http://farmer.e-agro.ph/index.php " class="inline-flex items-center bg-green-500 text-white font-bold border-0 py-2 px-3  rounded text-base mt-4 md:mt-0">Login</a>
                    {/* REGISTER */}
                <a href="http://farmer.e-agro.ph/verify.php" class="inline-flex items-center bg-green-500 text-white font-bold border-0 py-2 px-3  rounded text-base mt-4 md:mt-0">Register</a>
            </div>

        </Nav>
    )
}

export default Dropdown